export default __webpack_public_path__ + "static/media/commercial.354c5871.png";